import React, {Component} from 'react';
import AccountProfile from './AccountProfile';
import {reduxForm} from 'redux-form';
import {validate} from '../../components/common/ProfileValidation';
import {connect} from 'react-redux';
import {updateETMSUser} from '../../actions/index'

class AccountProfileController extends Component {

    render() {
        return (
            <div>
                <h1>Account details</h1>

                <form onSubmit={this.props.handleSubmit((values) => {this.props.dispatch(updateETMSUser(values))})}>
                    <AccountProfile user={this.props.user} onEmailVerificationClick={this.props.onEmailVerificationClick}/>
                    {this.props.valid && this.props.dirty && <button className="submit" type="submit">Update</button>}
                </form>
            </div>
        );
    }
}

AccountProfileController = reduxForm({
    form: 'accountDetails',
    validate
})(AccountProfileController);

export default AccountProfileController = connect((_, props) => {
    return {
        initialValues: {
            name: (props.user || {}).name,
            email: (props.user || {}).email,
            phone: (props.user || {}).phone
        }
    }
})(AccountProfileController);




// WEBPACK FOOTER //
// ./src/components/account/AccountProfileController.jsx